import React from 'react'
import {TextArea, Form, Button, Message, Icon, Modal, Select, Image, Confirm, Label, Grid, Dropdown} from 'semantic-ui-react'
import ReactDOM from 'react-dom'
import Thumbnail from '../thumbnail-edit/index'
import CreatableSelect from 'react-select/creatable/dist/react-select.esm'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import {connect} from 'react-redux'
import { createAPIClient, createAWSClient } from '../../../../../services/api'
import { updateIssueAction, deleteIssueAction } from '../../../../../actions/issues.action'

const {Field} = Form
const listStyle = {'padding': 0}
const listItemStyle = {display: 'block', marginBottom: '5px'}
const modalStyle = {marginTop: '0px !important', marginLeft: 'auto', marginRight: 'auto'}
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

class EditForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      openConfirm: false,
      enableFileUpload: false,
      editingError: false,
      editingIssue: {
        isLoading: false,
        imageUploading: false,
        error: false,
        id: '',
        title: '',
        description: '',
        custom_field_values: {},
        attachments: []
      },
      originalEditingIssue: {}
    }
  }

  componentWillUpdate (nextProps, nextState, nextContext) {
    if (this.props.isEditing === false && nextProps.isEditing === true) {
      this.setState({
        editingIssue: nextProps.editingIssue,
        originalEditingIssue: JSON.parse(JSON.stringify(nextProps.editingIssue))
      })
    }
  }

  showConfirm () {
    this.setState({openConfirm: true})
  }
  handleCancel () {
    this.setState({openConfirm: false})
  }
  handleConfirm () {
    this.props.deleteIssueAction(this.state.editingIssue.id)
    this.setState({openConfirm: false})
    this.props.cancelEdit()
  }
  onAttachmentChange (e) {
    var attachmentNode = ReactDOM.findDOMNode(this.refs.attachment)
    var file = attachmentNode.files[0]
    if (file !== undefined) {
      this.uploadFile(file)
    }
  }
  uploadFile (file) {
    // send a post request and get upload url
    changeUploadingState.bind(this)(true)
    const api = createAPIClient()
    const extension = file.name.split('.')[1]
    const fileName = file.name.split('.')[0].replace(/ /g, '') + '_' + (new Date()).getTime() + '.' + extension

    api.get(`/api/private/upload/url-files?filename=${fileName}&type=incident-attachment`)
      .then(result => {
        const url = result.data.response
        const awsClient = createAWSClient()
        awsClient.put(url, file, {})
          .then(() => {
            var saveUrl = url.split('?')[0]
            var attachments = []
            attachments = attachments.concat(this.state.editingIssue.attachments)
            attachments.push({url: saveUrl, key: saveUrl})
            const updatedEditingIssue = Object.assign({}, this.state.editingIssue, {
              attachments: attachments
            })
            this.setState({editingIssue: updatedEditingIssue})
            changeUploadingState.bind(this)(false)
            ReactDOM.findDOMNode(this.refs.attachment).value = ''
            this.setState({
              enableFileUpload: false
            })
          })
          .catch(error => {
            console.log(error)
            changeUploadingState.bind(this)(false)
          })
      })
      .catch(error => {
        console.log(error)
        changeUploadingState.bind(this)(false)
      })

    function changeUploadingState (status) {
      const editingIssue = Object.assign({}, this.state.editingIssue)
      editingIssue.imageUploading = status
      this.setState({editingIssue})
    }
  }
  // uploadFile (e) {
  //   var attachmentNode = ReactDOM.findDOMNode(this.refs.attachment)
  //   var file = attachmentNode.files[0]
  //   this.props.uploadFile(file, () => {
  //
  //   })
  // }
  // removeAttachment (id, key) {
  //   this.props.removeAttachment(id, key)
  // }
  onSelectChange (id, e, {value}) {
    this.onChange({target: {name: id, value: value}})
  }
  onSelectChangeEditable (id, e) {
    let value
    if (e.__isNew__) {
      value = e.value
    } else {
      value = e.value
    }
    this.onChange({target: {name: id, value: value}})
  }
  onDateChange (id, date) {
    this.onChange({target: {name: id, value: date && date.toISOString()}})
  }
  onLabelChange (e, {value}) {
    this.onChange({target: {name: 'label', value: value}})
  }
  onSubmitEdit (e) {
    const submitEdit = {
      title: this.state.editingIssue.title,
      description: this.state.editingIssue.description,
      label: this.state.editingIssue.label,
      custom_field_values: [],
      attachments: []
    }

    for (let key in this.state.editingIssue.custom_field_values) {
      var obj = this.state.editingIssue.custom_field_values[key]
      if (obj.value) {
        delete obj['updated_at']
        delete obj['created_at']
        submitEdit.custom_field_values.push(obj)
      }
    }
    submitEdit.attachments = this.state.editingIssue.attachments
    this.props.updateIssueAction(this.state.editingIssue.id, submitEdit, (result) => {
      if (result) {
        this.props.cancelEdit()
      } else {
        this.setState({editingError: true})
      }
    })
  }
  onArchiveIssue () {
    const submitEdit = {
      title: this.state.originalEditingIssue.title,
      description: this.state.originalEditingIssue.description,
      label: this.state.originalEditingIssue.label,
      custom_field_values: [],
      attachments: [],
      archived: !this.state.originalEditingIssue.archived
    }

    for (let key in this.state.originalEditingIssue.custom_field_values) {
      var obj = this.state.originalEditingIssue.custom_field_values[key]
      if (obj.value) {
        delete obj['updated_at']
        delete obj['created_at']
        submitEdit.custom_field_values.push(obj)
      }
    }
    submitEdit.attachments = this.state.originalEditingIssue.attachments
    this.props.updateIssueAction(this.state.originalEditingIssue.id, submitEdit, (result) => {
      if (result) {
        this.props.cancelEdit()
      } else {
        this.setState({editingError: true})
      }
    })
  }
  removeAttachment (id, key) {
    const attachments = []
    if (id !== undefined) {
      for (let i = 0; i < this.state.editingIssue.attachments.length; i++) {
        if (this.state.editingIssue.attachments[i]._id !== id) {
          attachments.push(this.state.editingIssue.attachments[i])
        }
      }
    } else {
      for (let i = 0; i < this.state.editingIssue.attachments.length; i++) {
        if (this.state.editingIssue.attachments[i].key !== key) {
          attachments.push(this.state.editingIssue.attachments[i])
        }
      }
    }
    const updatedEditingIssue = Object.assign({}, this.state.editingIssue, {
      attachments: attachments
    })
    this.setState({editingIssue: updatedEditingIssue})
  }
  onChange (e) {
    const targetName = e.target.name
    const targetValue = e.target.value
    if (targetName === 'title' || targetName === 'description' || targetName === 'label') {
      const updatedEditingIssue = Object.assign({}, this.state.editingIssue, {
        [targetName]: targetValue ? targetValue : null
      })
      this.setState({
        editingIssue: updatedEditingIssue
      })
    } else {
      const updatedEditingIssue = Object.assign({}, this.state.editingIssue)
      updatedEditingIssue.custom_field_values[targetName] = {value: targetValue, custom_field: targetName}
      this.setState({
        editingIssue: updatedEditingIssue
      })
    }
  }
  render () {
    var currentTemplate = this.props.templates.filter((temp) => {
      return temp.id === this.props.templateId
    })[0]
    var teamMemberOptions = currentTemplate && currentTemplate.all_users.map(teamMember => {
      return {key: teamMember.id, value: teamMember.id, text: teamMember.first_name +' '+teamMember.last_name}
    })
    const uploadButton = (
      <Label
        as='label'
        basic
        htmlFor='attachment'
      >
        <Button
          icon='upload'
          label={{
            basic: true,
            content: 'Attach file(s)'
          }}
          labelPosition='right'
          loading={this.state.editingIssue.imageUploading}
        />
        <input
          hidden
          id='attachment'
          name='attachment'
          onChange={this.onAttachmentChange.bind(this)}
          multiple
          type='file'
          ref='attachment'
        />
      </Label>

    )

    const editFormAttachmentList = (
      <Grid columns='5' divided>
        <Grid.Row>
          {this.state.editingIssue.attachments.map((item, index) => {
            return (
              <Grid.Column key={item._id}>
                <Thumbnail edit={true} src={item.url} url={item.url} />
                <a style={{color: 'red'}} href='#' onClick={this.removeAttachment.bind(this, item._id, item.key)}> <Icon name='close' /><u>Delete </u></a>
              </Grid.Column>
            )
          })}
        </Grid.Row>
      </Grid>
    )
    let labelOptions = this.props.labels.map(label => {
      return {
        key: label.id,
        text: label.name,
        value: label.id,
        label: { color: label.color, empty: true, circular: true }
      }
    })
    labelOptions.unshift({text: 'Select Label', value: undefined})
    const editForm = (
      <div>
        <Form id='editForm' loading={this.state.editingIssue.isLoading} onSubmit={this.onSubmitEdit.bind(this)}>
          {this.state.editingError ? (
            <Message negative>
              <Message.Header>Something went wrong</Message.Header>
            </Message>
          ) : undefined}
          {this.props.customFields.map(item => {
            return (
              <Field key={item.id}>
                <label>{item.name}{item.required ? '*' : ''}</label>
                {(() => {
                  switch (item.value_type) {
                    case 'Single select (API)':
                      return (
                        <Select placeholder='Select a value'
                                id='field_value_type' name='field_value_type'
                                defaultValue={this.state.editingIssue.custom_field_values[item.id] && this.state.editingIssue.custom_field_values[item.id].value}
                                options={[{key: 'empty', value: '', text: 'Select a value'}].concat(item.list_values.map(value => {
                                  return ({key: value, value: value, text: value})
                                }))
                                }
                                onChange={this.onSelectChange.bind(this, item.id)}
                        />
                      )
                    case 'Picklist':
                      return (
                        <CreatableSelect
                          isClearable
                          defaultValue={{
                            value: this.state.editingIssue.custom_field_values[item.id] && this.state.editingIssue.custom_field_values[item.id].value,
                            label: this.state.editingIssue.custom_field_values[item.id] && this.state.editingIssue.custom_field_values[item.id].value
                          }}
                          onChange={this.onSelectChangeEditable.bind(this, item.id)}
                          options={[{value: '', label: 'Select a value'}].concat(item.list_values.map(value => {
                            return ({value: value, label: value})
                          }))
                          }
                        />
                      )
                    case 'TeamMember':
                      return (
                        <Dropdown
                          fluid
                          selection
                          multiple
                          options={teamMemberOptions}
                          defaultValue={this.state.editingIssue.custom_field_values[item.id] && this.state.editingIssue.custom_field_values[item.id].value}
                          onChange={this.onSelectChange.bind(this, item.id)}

                        />
                      )
                    case 'Calendar':
                      return (
                        <DatePicker
                          selected={this.state.editingIssue.custom_field_values[item.id] && (moment(this.state.editingIssue.custom_field_values[item.id].value).isValid() ? moment(this.state.editingIssue.custom_field_values[item.id].value).toDate() : undefined)}
                          onChange={this.onDateChange.bind(this, item.id)}
                          showTimeInput
                          dateFormat="dd/MM/yyyy h:mm aa"
                        />
                      )
                    default:
                      return (
                        <TextArea rows={1} autoHeight id={item.id} name={item.id} onChange={this.onChange.bind(this)}
                                  value={this.state.editingIssue.custom_field_values[item.id] && this.state.editingIssue.custom_field_values[item.id].value}
                                  required={item.required} />
                      )
                  }
                })()}
              </Field>
            )
          })}
          <Field>
            <label>Label</label>
            <Dropdown placeholder='Select Label' fluid selection options={labelOptions} onChange={this.onLabelChange.bind(this)} defaultValue={this.state.editingIssue.label && this.state.editingIssue.label.id} />
          </Field>
          <h5>Attachment list</h5>
          {editFormAttachmentList}
          <br />
          {uploadButton}
        </Form>
      </div>
    )

    const modal = (
      <Modal open={this.props.isEditing} style={modalStyle} onClose={this.props.cancelEdit}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Record
          <a href='#'>
            <Image onClick={this.props.cancelEdit} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}} avatar src={'/icons/close_432859.svg'} />
          </a>
          <a href='#'>
            <Image onClick={this.showConfirm.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px', marginRight: '20px'}} avatar src={'/icons/delete_1397562.svg'} />
          </a>
          <Confirm
            style={confirmStyle}
            open={this.state.openConfirm}
            onCancel={this.handleCancel.bind(this)}
            onConfirm={this.handleConfirm.bind(this)}
            content='Are you sure you want to delete this record?'
            confirmButton='Yes'
          />
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {editForm}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button icon={this.state.editingIssue.archived ? 'undo' : 'archive'} content={this.state.editingIssue.archived ? 'Unarchive' : 'Archive'} onClick={this.onArchiveIssue.bind(this)} />
          <Button primary icon='check' content='Update' type='submit' form='editForm' />
        </Modal.Actions>
      </Modal>
    )
    return modal
  }
}

function mapStateToProps (state) {
  return {location: state.account.user.locations[0], templates: state.templates.templates}
}

export default connect(mapStateToProps, {updateIssueAction, deleteIssueAction})(EditForm)




// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/edit/index.js